import styles from './logo.module.scss';
import { Link } from 'react-router-dom';
import Wordmark from '@/assets/icons/voicesphere-wordmark.svg?react';
import Mark from '@/assets/icons/voicesphere-mark.svg?react';

interface LogoProps {
  onLogoClick?: () => void;
  collapsed?: boolean;
}

export default function Logo({ onLogoClick, collapsed = false }: LogoProps) {
  // The wordmark needs ~132px; the collapsed rail is 80px, so it shows the mark alone.
  const Glyph = collapsed ? Mark : Wordmark;

  return (
    <Link onClick={onLogoClick} to="/" className={styles.logo} aria-label="VoiceSphere">
      <Glyph data-testid="logo-icon" className={collapsed ? styles.mark : styles.wordmark} />
    </Link>
  );
}
